<template>
  <div id="app">
    <div v-if="isAuth()" class="full-height">
      <Menu>
        <transition name="fade-slide-up" mode="out-in">
          <router-view />
        </transition>
      </Menu>
    </div>
    <div v-if="!isAuth()" class="full-height">
      <Login />
    </div>
    <NotificationsApp />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'

import { connectSocket } from '@/utils/web-socket'

import Menu from './components/Menu'
import NotificationsApp from './components/NotificationsApp'
import store from './store'
import { initFirebase, serviceWorker } from './utils/firebase.helper'
import http from './utils/http'
import Login from './views/auth/Login'

export default {
  components: { Menu, Login, NotificationsApp },
  async beforeMount() {
    serviceWorker()
    initFirebase()

    http.getIp().then((e) => store.commit('setIp', e))

    if (this.isAuth()) {
      connectSocket()
      Sentry.setUser({
        email: store.state.auth.user.email,
        id: store.state.auth.user.id,
        username: store.state.auth.user.username,
        ip_address: '{{auto}}',
      })
    } else {
      Sentry.setUser({
        ip_address: '{{auto}}',
      })
    }
  },
  mounted() {
    // if (this.isAuth() === false) {
    //     document.getElementById('sentry-feedback').style.display = 'none';
    // }
  },
  methods: {
    isAuth() {
      return this.$store.state.auth.isAuthenticated
    },
  },
}
</script>
<style lang="scss">
html,
body,
#app,
.full-height {
  height: 100%;
  margin: 0;
}

.md-dialog ::v-deep .md-dialog-container {
  transform: none;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 9px 11px 0 rgba(0, 0, 0, 0.1),
    0 9px 15px 0 rgba(0, 0, 0, 0.02);
}

.md-overlay {
  background: rgba(0, 0, 0, 0.12) !important;
}

.md-dialog-container {
  transform: translate(0%, 0%) scale(1) !important;
}

.fade-slide-up-enter-active {
  transition: all 0.2s ease;
}

.fade-slide-up-leave-active {
  transition: all 0.2s ease;
}

.fade-slide-up-enter,
.fade-slide-up-leave-to {
  opacity: 0;
}
</style>
